export default __webpack_public_path__ + "static/media/tokenImageAcium.c90920b2.svg";